import { Market } from '../../graphql/API';
import { OptionEntry } from '../../utils/generate-options';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminListVenuesMarketsAsOptionsApi = async (): Promise<OptionEntry[]> => {
  const result = await executeGql<Market[]>(adminListMarketsForOptionsQuery, {});
  const items = processGqlResult<Market[]>('adminListMarkets.items', result);

  return items.map<OptionEntry>((m: Market) => {
    return {
      key: m.id || '',
      value: `${m.name} (${m.totalVenues})`,
    };
  });
};

const adminListMarketsForOptionsQuery = /* GraphQL */ `
  query AdminListMarkets {
    adminListMarkets(
      filter: {
        status: active
        sortBy: "totalVenues"
        sortDirection: "desc"
        limit: 10000
        offset: 0
      }
    ) {
      items {
        countryCode
        id
        name
        stateProvince
        totalVenues
      }
    }
  }
`;
